import React, { useState, useEffect } from 'react';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import { postPaypalApprove } from 'api';
import { usePaypalOptions } from './usePaypalOptions';

function Paypal(props) {
  const {
    disabled,
    createOrder,
    createSubscription,
    fulfillSubscription,
    onApprove,
    onError,
  } = props;

  const [clicked, setClicked] = useState(false);

  const options = usePaypalOptions(!!createSubscription);

  const [{ isPending, isRejected }, dispatchPaypalScript] = usePayPalScriptReducer();
  useEffect(() => {
    if (isRejected && options) dispatchPaypalScript({ type: 'resetOptions', value: options });
  }, [isRejected, options, dispatchPaypalScript]);

  // Avoid focus-only first click while the SDK script is still loading.
  if (isPending) {
    return null;
  }

  return (
    (clicked || !disabled) && (
      <PayPalButtons
        disabled={!!disabled && !clicked}
        createOrder={
          !createSubscription && createOrder
            ? (data, actions) => {
                setClicked(true);
                return createOrder(data, actions);
              }
            : undefined
        }
        createSubscription={
          createSubscription
            ? (data, actions) => {
                setClicked(true);
                return createSubscription(data, actions);
              }
            : undefined
        }
        onApprove={async (data, actions) => {
          setClicked(false);
          try {
            if (createSubscription) {
              if (fulfillSubscription) {
                await fulfillSubscription(data.subscriptionID, data);
              } else {
                await postPaypalApprove({ subscription_id: data.subscriptionID });
              }
            } else if (createOrder) {
              await postPaypalApprove({ order_id: data.orderID });
            }
          } catch (err) {
            // Capture/fulfill can fail after PayPal approve. Surface via onError;
            // do not treat as success.
            if (onError) {
              onError(err);
            }
            return;
          }
          if (onApprove) {
            await onApprove(data, actions);
          }
        }}
        onError={onError}
        style={{
          label: 'pay',
          shape: 'rect',
          color: 'silver',
        }}
      />
    )
  );
}

export default Paypal;
